// extracted by mini-css-extract-plugin
export default {"nav":"home_nav__5MrfD"};